import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/sample/')({
  component: () => (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1 style={{ marginBottom: '10px', color: '#333' }}>
        Index Route (메인)
      </h1>
      <p style={{ marginBottom: '30px', color: '#666', fontSize: '14px' }}>
        TanStack Router의 모든 라우팅 개념을 시연하는 예시 페이지입니다.
      </p>
      <nav>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          <li style={{ marginBottom: '10px' }}>
            <Link to="./basic">Basic Route</Link>
          </li>
          <li style={{ marginBottom: '10px' }}>
            <Link to="./posts">Layout Route (Posts)</Link>
          </li>
          <li style={{ marginBottom: '10px' }}>
            <Link to="./posts/123">Dynamic Route (/posts/123)</Link>
          </li>
          <li style={{ marginBottom: '10px' }}>
            <Link to="./posts/123/edit">Nested Dynamic (/posts/123/edit)</Link>
          </li>
          <li style={{ marginBottom: '10px' }}>
            <Link to="./files/docs/readme.md">
              Splat Route (/files/docs/readme.md)
            </Link>
          </li>
          <li style={{ marginBottom: '10px' }}>
            <Link to="./a">Pathless Layout A</Link>
          </li>
          <li style={{ marginBottom: '10px' }}>
            <Link to="./b">Pathless Layout B</Link>
          </li>
          <li style={{ marginBottom: '10px' }}>
            <Link to="./products">Products Layout</Link>
          </li>
          <li style={{ marginBottom: '10px' }}>
            <Link to="./products/123">Nested Route (/products/123)</Link>
          </li>
          <li style={{ marginBottom: '10px' }}>
            <Link to="./products/456/detail">
              Non-Nested Route (/products/456/detail)
            </Link>
          </li>
          <li style={{ marginBottom: '10px' }}>
            <Link to="./group-a">Group A</Link>
          </li>
          <li style={{ marginBottom: '10px' }}>
            <Link to="./group-b">Group B</Link>
          </li>
        </ul>
      </nav>
    </div>
  ),
});
